import {
  AppBar,
  Divider,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Gavel as GavelIcon,
  Groups as GroupsIcon,
  Analytics as AnalyticsIcon,
} from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarsStaggered } from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ currentTab, handleTabChange, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#FFFFFF",
        mb: "5px",
        color: "#003D78",
        width: "100%",
        borderRadius: "8px",
        boxShadow: "none",
        height: "40px",
      }}
    >
      <Toolbar variant="dense" sx={{ minHeight: "40px" }}>
        {/* Title - Hidden on mobile */}
        <Typography
          sx={{
            display: { xs: "none", lg: "block" },
            fontSize: "18px",
            fontWeight: "bold",
            color: "#003D78",
            flexShrink: 0,
            mr: 2,
            width: { md: "33%" },
          }}
        >
          Case Management System
        </Typography>

        {currentTab !== 0 && (
          <Box>
            <IconButton
              size="small"
              sx={{ display: { xs: "flex", lg: "none" } }}
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faBarsStaggered} />
            </IconButton>
          </Box>
        )}
        {/* Tabs Container */}
        <Box sx={{ flexGrow: 1, overflowX: "auto" }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons="auto"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#003D78",
              },
            }}
            sx={{
              minHeight: 40,
              "& .MuiTabs-flexContainer": {
                ...(isMobile ? { justifyContent: "center" } : {}),
              },
            }}
          >
            <Tab
              icon={<DashboardIcon fontSize="small" />}
              iconPosition={isMobile ? "top" : "start"}
              label={!isMobile && "Dashboard"}
              sx={{
                minHeight: 40,
                textTransform: "none",
                minWidth: isMobile ? 64 : 100,
                fontSize: theme.typography.pxToRem(14),
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  color: "#303f9f",
                  fontWeight: 600,
                },
                "& .MuiTab-iconWrapper": {
                  marginRight: theme.spacing(1),
                  fontSize: "16px",
                },
              }}
            />

            <Tab
              icon={<GavelIcon sx={{ color: "#a56d51" }} fontSize="small" />}
              iconPosition={isMobile ? "top" : "start"}
              label={!isMobile && "Cases"}
              sx={{
                minHeight: 40,
                textTransform: "none",
                minWidth: isMobile ? 64 : 100,
                fontSize: theme.typography.pxToRem(14),
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  color: "#303f9f",
                  fontWeight: 600,
                },
                "& .MuiTab-iconWrapper": {
                  marginRight: theme.spacing(1),
                  fontSize: "16px",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "25%",
                  height: "50%",
                  width: "1px",
                  backgroundColor: "#ccc",
                },
              }}
            />
            <Tab
              icon={<PeopleIcon sx={{ color: "#FF9800" }} fontSize="small" />}
              iconPosition={isMobile ? "top" : "start"}
              label={!isMobile && "Clients"}
              sx={{
                minHeight: 40,
                textTransform: "none",
                minWidth: isMobile ? 64 : 100,
                fontSize: theme.typography.pxToRem(14),
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  color: "#303f9f",
                  fontWeight: 600,
                },
                "& .MuiTab-iconWrapper": {
                  marginRight: theme.spacing(1),
                  fontSize: "16px",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "25%",
                  height: "50%",
                  width: "1px",
                  backgroundColor: "#ccc",
                },
              }}
            />

            <Tab
              icon={<GroupsIcon sx={{ color: "#4CAF50" }} fontSize="small" />}
              iconPosition={isMobile ? "top" : "start"}
              label={!isMobile && "Lawyers"}
              sx={{
                minHeight: 40,
                textTransform: "none",
                minWidth: isMobile ? 64 : 100,
                fontSize: theme.typography.pxToRem(14),
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  color: "#303f9f",
                  fontWeight: 600,
                },
                "& .MuiTab-iconWrapper": {
                  marginRight: theme.spacing(1),
                  fontSize: "16px",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "25%",
                  height: "50%",
                  width: "1px",
                  backgroundColor: "#ccc",
                },
              }}
            />

            <Tab
              icon={
                <AnalyticsIcon sx={{ color: "#F44336" }} fontSize="small" />
              }
              iconPosition={isMobile ? "top" : "start"}
              label={!isMobile && "Reports"}
              sx={{
                minHeight: 40,
                textTransform: "none",
                minWidth: isMobile ? 64 : 100,
                fontSize: theme.typography.pxToRem(14),
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  color: "#303f9f",
                  fontWeight: 600,
                },
                "& .MuiTab-iconWrapper": {
                  marginRight: theme.spacing(1),
                  fontSize: "16px",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "25%",
                  height: "50%",
                  width: "1px",
                  backgroundColor: "#ccc",
                },
              }}
            />
          </Tabs>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
